import { useEffect } from 'react';
export function useSwitchToVariantImage({ galleryImages, galleryRef, variant }) {
    const selectedVariation = variant;
    useEffect(() => {
        var _a, _b;
        // Do nothing if the requirements weren't passed in
        if (!galleryImages || !selectedVariation || !galleryRef)
            return;
        // Variants only ever have 1 image, but in the API it is still an array.
        // So, we just grab the first image
        const variantImageUrl = (_b = (_a = selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url;
        // Find the variant
        const galleryIndex = galleryImages.findIndex(image => image.url === variantImageUrl);
        // If the variant does not have an image, do nothing
        if (galleryIndex === -1)
            return;
        // Otherwise slide to it
        galleryRef.current.slideToIndex(galleryIndex);
    }, [galleryImages, galleryRef, selectedVariation]);
}
//# sourceMappingURL=useSwitchToVariantImage.js.map